import { recordPath, recordRoute } from '@/shared/registry'

/** Where the announcement pages live. */
export const announcementsPath = '/notifications/announcements'
export const createAnnouncementPath = `${announcementsPath}/new`
export const announcementRoute = recordRoute('notifications', 'announcements')
export const editAnnouncementRoute = `${announcementRoute}/edit`

/** An announcement's details page. */
export function announcementPath(id: string): string {
  return recordPath('notifications', 'announcements', id)
}

/** The base of Announcement Details' slots (`detailsSlots`). */
export const announcementDetailsSlot = 'notifications.announcement-details'

/** The API's announcement endpoints. */
export const announcementsApi = '/notifications/v1/announcements'

export function announcementApi(id: string): string {
  return `${announcementsApi}/${encodeURIComponent(id)}`
}

/** What each announcement action needs. */
export const readAnnouncementsPermission = 'notifications.announcement.read'
export const writeAnnouncementsPermission = 'notifications.announcement.write'
export const deleteAnnouncementsPermission = 'notifications.announcement.delete'

/** Making an announcement for every organization, or no longer for every one. */
export const everyOrganizationAnnouncementsPermission = 'notifications.announcement.for-every-organization.write'
